import { useCallback, useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import { parseCookies, setCookie } from 'nookies';
import { addDays } from 'date-fns';
import _ from 'lodash';

const NAME_OF_RECENT_GOODS_BANNER_COOKIE =
  'HS_RECENT_STORE_GDS_FIRST_BANNER_VIEW';
const NAME_OF_RECENT_GOODS_IMAGE_URL_COOKIE = 'HS_RECENT_STORE_GDS_IMAGE_URL';

const useRecentGoodsButton = () => {
  const router = useRouter();
  const cookies = parseCookies();
  const [isInit, setIsInit] = useState(false);
  const [recentGdsImageUrl, setRecentGdsImageUrl] = useState('');
  const [isOpenRecentBanner, setIsOpenRecentBanner] = useState(false);

  const recentGoodsImageUrl = useMemo(
    () =>
      _.trim(
        decodeURIComponent(
          _.get(cookies, NAME_OF_RECENT_GOODS_IMAGE_URL_COOKIE, ''),
        ),
      ),
    [cookies],
  );

  const recentGoodsBannervalue = useMemo(
    () =>
      _.trim(
        decodeURIComponent(
          _.get(cookies, NAME_OF_RECENT_GOODS_BANNER_COOKIE, ''),
        ),
      ),
    [cookies],
  );

  const handleGoRecentGoodsPage = useCallback(() => {
    router.push(
      `${process.env.NEXT_PUBLIC_HANSSEMMALL_MWEB_HOST}//mmypage/recentlyLookGoodsList.do`,
    );
  }, [router]);

  const setStateByCookie = useCallback(() => {
    setRecentGdsImageUrl(recentGoodsImageUrl);
    setIsOpenRecentBanner(recentGoodsBannervalue !== 'Y');
  }, [recentGoodsBannervalue, recentGoodsImageUrl]);

  const setRecentBannerViewCookie = useCallback(() => {
    setCookie(null, NAME_OF_RECENT_GOODS_BANNER_COOKIE, 'Y', {
      domain: `${process.env.NEXT_PUBLIC_COOKIE_DOMAIN}`,
      path: '/',
      expires: addDays(new Date(), 1),
      httpOnly: false,
    });
  }, []);

  const handleCloseRecentBanner = useCallback(() => {
    setTimeout(() => {
      setIsOpenRecentBanner(false);
    }, 3000);
  }, []);

  useEffect(() => {
    if (isInit) return;
    setStateByCookie();

    if (recentGoodsBannervalue !== 'Y' && recentGoodsImageUrl) {
      setRecentBannerViewCookie();
      handleCloseRecentBanner();
    }

    setIsInit(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { recentGdsImageUrl, isOpenRecentBanner, handleGoRecentGoodsPage };
};

export default useRecentGoodsButton;
